// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2KLs-","colMaxWidth":"Table_colMaxWidth__1N54N"};